"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const _internals_1 = require("../_internals");
const union_1 = __importDefault(require("./union"));
const show_1 = __importDefault(require("./show"));
const enum_1 = __importDefault(require("./enum"));
const eq_1 = __importDefault(require("./eq"));
const ord_1 = __importDefault(require("./ord"));
/**
 * Creates an enum type which is an Union that implements Eq, Ord, Enum, and Show.
 * Cases are treated as singletons so they are values in the type.
 * @param name Enum name
 * @param cases Cases that inhabit the Enum.
 */
const EnumType = (name, rawCases) => {
    return (0, union_1.default)(name, rawCases.reduce((acc, next) => (0, _internals_1.assoc)(next, () => { }, acc), {}), [
        (0, eq_1.default)({ empties: rawCases }),
        (0, ord_1.default)({ order: rawCases }),
        (0, enum_1.default)({ order: rawCases }),
        (0, show_1.default)({ overrides: {
                show: rawCases.reduce((acc, next) => {
                    return (0, _internals_1.assoc)(next, () => `[${name} => ${next}]`, acc);
                }, {})
            } }),
        (cases, globals) => {
            rawCases.forEach((key) => {
                globals[key] = new cases[key]();
                cases[key].prototype.getTag = () => key;
                cases[key].prototype.getVariant = () => key;
            });
        }
    ]).constructors({});
};
exports.default = EnumType;
